import { useEffect } from "react";

/**
 * Gets the total of tank levels for each amlGroup
 */
export const useAmlCalcTotal = ({
  id,
  setValue,
  amlGroup,
  amlTotal,
}: {
  id: string;
  setValue: (id: string, value: string) => void;
  amlGroup?: string;
  amlTotal?: string;
}) => {
  const amlId = amlTotal || amlGroup || null;
  if (!amlId) return;
  useEffect(() => {
    const sumAndSet = () => {
      const total = Array.from(
        document.querySelectorAll<HTMLDivElement>(`div.${amlId}_add > input`),
      ).reduce((acc, input) => {
        const val = parseFloat(String(input.value).replace(",", "."));
        return acc + (isNaN(val) ? 0 : val);
      }, 0);

      if (amlTotal) {
        // Defer setValue to prevent interfering with tab navigation
        setTimeout(() => {
          setValue(id, total ? total.toString() : "");
        }, 0);
      }
    };

    sumAndSet();

    // Attach blur event listeners on all inputs inside div.amlGroup
    const inputs = Array.from(
      document.querySelectorAll<HTMLInputElement>(`div.${amlId}_add > input`),
    );
    inputs.forEach(input => input.addEventListener("blur", sumAndSet));

    return () => {
      inputs.forEach(input => input.removeEventListener("blur", sumAndSet));
    };
  }, []);
};

/**
 * Gets the percentage of the tank level from amlCalc and value fields
 * and sets it to adjacent percentage field.
 */
export const useAmlCalcPerc = ({
  id,
  setValue,
  amlCalc,
  feature,
  rowIndex,
}: {
  id: string;
  setValue: (id: string, value: string) => void;
  amlCalc?: string;
  feature?: string;
  rowIndex: number;
}) => {
  if (feature !== "amlPerc" && !amlCalc) return;
  useEffect(() => {
    const getPerc = () => {
      const amlInput = document.querySelector<HTMLDivElement>(
        `div.amlPerc_${rowIndex} > input`,
      );
      const perc = amlInput
        ? (amlInput.value / Number(amlInput?.getAttribute("data-aml"))) * 100
        : 0;

      if (feature === "amlPerc") {
        setTimeout(() => {
          setValue(id, perc ? perc.toFixed(2).toString() : "");
        }, 0);
      }
    };

    getPerc(); // initial perc calculation

    const inputs = Array.from(
      document.querySelectorAll<HTMLInputElement>(`div.amlPerc > input`),
    );
    inputs.forEach(input => input.addEventListener("blur", getPerc));

    return () => {
      inputs.forEach(input => input.removeEventListener("blur", getPerc));
    };
  }, []);
};
